export const capitalizeFirstLetter = (string: string) => {
    if (!string) {
        return string;
    }
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const normalizeCategoryDisplayName = (name: string | undefined) => {
    return name?.replace(/Media/i, '').trim() || '';
};

/**
 * Splits a label onto (at most) two lines when it is long and contains a
 * space, so that e.g. "Online Media" renders as "Online" / "Media" instead of
 * being truncated to "Online M…". Names at or below `maxSingleLineLength`
 * characters, or single-word names, are returned unchanged on one line.
 *
 * The split point is the space nearest the middle of the string, which keeps
 * the two resulting lines as balanced as possible.
 */
export const wrapLabelOnSpace = (
    name: string,
    maxSingleLineLength = 10,
): string[] => {
    if (!name || name.length <= maxSingleLineLength || !name.includes(' ')) {
        return [name];
    }

    const middle = name.length / 2;
    let splitIndex = -1;
    let bestDistance = Infinity;

    for (let i = 0; i < name.length; i++) {
        if (name[i] !== ' ') {
            continue;
        }
        const distance = Math.abs(i - middle);
        if (distance < bestDistance) {
            bestDistance = distance;
            splitIndex = i;
        }
    }

    if (splitIndex === -1) {
        return [name];
    }

    return [
        name.slice(0, splitIndex).trim(),
        name.slice(splitIndex + 1).trim(),
    ];
};

/**
 * Builds the ECharts rich-text formatter fragment for a pie-slice category
 * name, wrapping long multi-word names across two lines. Each line is rendered
 * with the provided rich style key (defaults to `per`).
 */
export const buildWrappedNameFragment = (
    name: string,
    richKey = 'per',
): string => {
    return wrapLabelOnSpace(name)
        .map((line) => `{${richKey}|${line}}`)
        .join('\n');
};
